import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import usePrefersReducedMotion from "../../hooks/usePrefersReducedMotion";
const SimpleTransition = ({ children, animationKey, className, ref, }) => {
    const prefersReducedMotion = usePrefersReducedMotion();
    if (prefersReducedMotion)
        return (React.createElement("div", { key: animationKey, ref: ref, className: className }, children));
    return (React.createElement(AnimatePresence, { mode: "wait" },
        React.createElement(motion.div, { key: animationKey, ref: ref, className: className, initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }, children)));
};
export default SimpleTransition;
//# sourceMappingURL=SimpleTransition.js.map